import InnerNav from "../../../components/InnerNav/InnerNav";
import Zodiac from "../../../components/ZodiacSign/Zodiac";
import "./Destiny.scss";
import arrow from "../../../assets/arrow.png";
import { useState } from "react";
import Footer from "../../../components/Footer/Footer";
import { Link } from "react-router-dom";
import axios from "axios";



export const destinyProfiles = {
  1: {
    title: "Destiny Number 1 – The Leader",
    keywords: "Independence · Ambition · Innovation",
    overview:
      "Destiny Number 1 represents originality, confidence and leadership. You are meant to create your own path and inspire others.",
    strengths: [
      "Strong leadership and initiative",
      "Self-reliant and confident",
      "Creative problem solver",
      "Ability to turn ideas into action"
    ],
    challenges: [
      "Being overly controlling",
      "Difficulty accepting advice",
      "Impatience toward slower people",
      "Fear of appearing weak"
    ],
    guidance:
      "Lead with humility, not force. Collaborate more. Your power grows when you uplift others instead of competing.",
  },

  2: {
    title: "Destiny Number 2 – The Peacemaker",
    keywords: "Harmony · Cooperation · Sensitivity",
    overview:
      "You are destined to build relationships, mediate conflicts and create peace wherever you go.",
    strengths: [
      "Excellent teamwork and diplomacy",
      "Emotional intelligence",
      "Intuitive understanding of people",
      "Supportive and caring"
    ],
    challenges: [
      "Over-sensitivity",
      "Difficulty making decisions alone",
      "Avoiding conflict even when needed"
    ],
    guidance:
      "Stand firm when required. Your gift is harmony, but boundaries protect your energy.",
  },

  3: {
    title: "Destiny Number 3 – The Communicator",
    keywords: "Creativity · Expression · Joy",
    overview:
      "Your destiny lies in expressing ideas, inspiring others and spreading positivity through communication.",
    strengths: [
      "Excellent speaker/writer",
      "Creative and artistic",
      "Optimistic and energetic"
    ],
    challenges: [
      "Scattered focus",
      "Not finishing what you start",
      "Avoiding serious issues"
    ],
    guidance:
      "Use discipline to support your creativity. Consistency brings success.",
  },

  4: {
    title: "Destiny Number 4 – The Builder",
    keywords: "Stability · Structure · Discipline",
    overview:
      "You are destined to build systems, foundations and long-lasting structures through dedication and hard work.",
    strengths: [
      "Organised and reliable",
      "Strong work ethic",
      "Great planner and strategist"
    ],
    challenges: [
      "Rigidity",
      "Fear of change",
      "Overworking without joy"
    ],
    guidance:
      "Stay open to new ideas. Balance discipline with flexibility.",
  },

  5: {
    title: "Destiny Number 5 – The Explorer",
    keywords: "Freedom · Adventure · Change",
    overview:
      "Your destiny is to experience life, adapt to change and inspire others with your courage and curiosity.",
    strengths: [
      "Adaptable and quick-learning",
      "Loves variety and travel",
      "Energetic and courageous"
    ],
    challenges: [
      "Restlessness",
      "Impulsive decisions",
      "Difficulty committing"
    ],
    guidance:
      "Focus your energy. Freedom grows stronger when supported by purpose.",
  },

  6: {
    title: "Destiny Number 6 – The Nurturer",
    keywords: "Responsibility · Love · Service",
    overview:
      "You are destined to support, guide and heal others. Family and responsibility play a major role in your life.",
    strengths: [
      "Caring and protective",
      "Excellent teacher/healer",
      "Creates harmony and beauty"
    ],
    challenges: [
      "Taking on too much",
      "Over-worrying",
      "Feeling unappreciated"
    ],
    guidance:
      "Give without losing yourself. Boundaries create healthy relationships.",
  },

  7: {
    title: "Destiny Number 7 – The Seeker",
    keywords: "Wisdom · Intuition · Analysis",
    overview:
      "Your path is one of knowledge, research and spiritual awakening. You seek truth beyond the surface.",
    strengths: [
      "Deep thinker",
      "Highly intuitive",
      "Skilled in research"
    ],
    challenges: [
      "Isolation",
      "Overthinking",
      "Difficulty expressing emotions"
    ],
    guidance:
      "Balance intellect with emotion. Share your wisdom—don’t hide it.",
  },

  8: {
    title: "Destiny Number 8 – The Achiever",
    keywords: "Power · Success · Mastery",
    overview:
      "Your destiny is to achieve material success and influence. You understand management, business and authority.",
    strengths: [
      "Strong leadership",
      "Business intelligence",
      "Persistence and ambition"
    ],
    challenges: [
      "Workaholism",
      "Power struggles",
      "Stress and pressure"
    ],
    guidance:
      "Use power responsibly. Align ambition with integrity.",
  },

  9: {
    title: "Destiny Number 9 – The Humanitarian",
    keywords: "Compassion · Creativity · Wisdom",
    overview:
      "Your destiny leads you to help humanity, create beauty and uplift others emotionally.",
    strengths: [
      "Compassionate and generous",
      "Creative and artistic",
      "Wise beyond years"
    ],
    challenges: [
      "Difficulty letting go",
      "Emotional overwhelm",
      "Self-sacrifice"
    ],
    guidance:
      "Prioritise self-care. You can help others only when your own cup is full.",
  },

  11: {
    title: "Destiny Number 11 – The Inspired Teacher",
    keywords: "Spirituality · Vision · Intuition",
    overview:
      "A Master Number destiny—11 is a spiritual messenger here to awaken others.",
    strengths: [
      "Strong intuition",
      "Magnetic personality",
      "Inspirational leadership"
    ],
    challenges: ["Anxiety", "Self-doubt", "Over-sensitivity"],
    guidance:
      "Ground yourself. Use intuition in practical steps.",
  },

  22: {
    title: "Destiny Number 22 – The Master Builder",
    keywords: "Greatness · Structure · Impact",
    overview:
      "You are destined to build something of global value—22 is the most powerful Master Number.",
    strengths: [
      "Visionary thinking",
      "Massive potential",
      "Extraordinary discipline"
    ],
    challenges: [
      "Pressure",
      "Fear of failure",
      "Over-responsibility"
    ],
    guidance:
      "Break big goals into small steps. Stay humble and focused.",
  },
};


const Destiny = () => {

  const [formData, setFormData] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    year: "2000",
    month: "May",
    day: "26",
    gender: "male" // ✅ DEFAULT, NO UI
  });


  const [resultData, setResultData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showReport, setShowReport] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { firstName, lastName, year, month, day } = formData;
    const birthDay = Number(day);
    const birthMonth = new Date(`${month} 1, 2000`).getMonth() + 1;
    const birthYear = Number(year);

    try {
      setLoading(true);

      const { gender } = formData;

      const res = await axios.get(
        `https://core-c343.onrender.com/api/lucky-number` +
        `?firstName=${firstName}` +
        `&lastName=${lastName}` +
        `&birthYear=${birthYear}` +
        `&birthMonth=${birthMonth}` +
        `&birthDay=${birthDay}` +
        `&gender=${gender}`
      );


      setResultData(res.data);
      setShowReport(true);
    } catch (err) {
      setResultData({
        error: "Unable to generate your Destiny Number report. Please try again.",
      });
      setShowReport(true);
    } finally {
      setLoading(false);
    }
  };

  const handleTryAgain = () => {
    setShowReport(false);
    setResultData(null);
  };

  const destinyNum = resultData?.data?.numerology?.destinyNumber;
  const profile = destinyNum ? destinyProfiles[destinyNum] : null;

  return (
    <div className="destiny-container">
      <InnerNav />

      <div className="destiny-content">
        <Zodiac />

        <div className="left-numerology">

          {/* FORM VIEW */}
          {!showReport && (
            <>
              <div className="header">
                <h1>Destiny Number Calculator</h1>
                <p>
                  Enter your details to discover your <strong>life purpose, strengths and destiny path</strong>.
                </p>
              </div>

              <div className="form-card">
                <form onSubmit={handleSubmit} className="form-grid">

                  <input
                    name="firstName"
                    placeholder="First Name"
                    value={formData.firstName}
                    onChange={handleChange}
                    required
                  />

                  <input
                    name="middleName"
                    placeholder="Middle Name (Optional)"
                    value={formData.middleName}
                    onChange={handleChange}
                  />

                  <input
                    name="lastName"
                    placeholder="Last Name"
                    value={formData.lastName}
                    onChange={handleChange}
                    required
                  />

                  <div className="dob-grid">
                    <select name="day" value={formData.day} onChange={handleChange}>
                      {[...Array(31)].map((_, i) => (
                        <option key={i + 1}>{i + 1}</option>
                      ))}
                    </select>

                    <select name="month" value={formData.month} onChange={handleChange}>
                      {[
                        "January", "February", "March", "April", "May", "June",
                        "July", "August", "September", "October", "November", "December"
                      ].map((m) => (
                        <option key={m}>{m}</option>
                      ))}
                    </select>

                    <select name="year" value={formData.year} onChange={handleChange}>
                      {Array.from({ length: 110 }).map((_, i) => {
                        const y = 2025 - i;
                        return <option key={y}>{y}</option>;
                      })}
                    </select>
                  </div>
                  <select
                    name="gender"
                    value={formData.gender}
                    onChange={handleChange}
                    required
                  >
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="other">Other</option>
                  </select>


                  <button type="submit" className="primary-btn" disabled={loading}>
                    {loading ? "Generating..." : "Show My Destiny Number"}
                  </button>

                </form>
              </div>
            </>
          )}

          {/* REPORT VIEW */}
          {showReport && (
            <div className="report-card">

              <h1>Your Destiny Number Report</h1>

              {resultData?.error ? (
                <p className="error-text">{resultData.error}</p>
              ) : (
                <>
                  <div className="hero-number-box">
                    <div className="number-circle">{destinyNum}</div>
                    <h2>{profile?.title}</h2>
                    <p className="keywords">{profile?.keywords}</p>
                  </div>

                  <div className="report-section">
                    <h3>Overview</h3>
                    <p>{profile?.overview}</p>
                  </div>

                  <div className="report-section">
                    <h3>Your Strengths</h3>
                    <ul>{profile?.strengths.map((s, i) => <li key={i}>{s}</li>)}</ul>
                  </div>

                  <div className="report-section">
                    <h3>Your Challenges</h3>
                    <ul>{profile?.challenges.map((c, i) => <li key={i}>{c}</li>)}</ul>
                  </div>

                  <div className="report-section">
                    <h3>Guidance</h3>
                    <p>{profile?.guidance}</p>
                  </div>
                </>
              )}

              <button className="try-again-btn" onClick={handleTryAgain}>
                Try Again
              </button>
            </div>
          )}
        </div>

        {/* RIGHT SIDEBAR */}
        <div className="right-numerology">
          <h4>Related Links</h4>
          <div className="right-links">
            <Link to="/numerology/luckynum"><p><img src={arrow} /> Lucky Number</p></Link>
            <Link to="/numerology/chinese-lucky"><p><img src={arrow} /> Chinese Lucky</p></Link>
            <Link to="/numerology/unlucky"><p><img src={arrow} /> Unlucky Number</p></Link>
            <Link to="/numerology/life-path"><p><img src={arrow} /> Life Path</p></Link>
            <Link to="/numerology/destiny"><p><img src={arrow} /> Destiny Number</p></Link>
            <Link to="/numerology/birth"><p><img src={arrow} /> Birth or Root Number</p></Link>
            <Link to="/numerology/soul"><p><img src={arrow} /> Soul Urge Number</p></Link>
            <Link to="/numerology/name"><p><img src={arrow} /> Name Number</p></Link>
            <Link to="/numerology/balance"><p><img src={arrow} /> Balance Number</p></Link>
            <Link to="/numerology/lo-shu-grid"><p><img src={arrow} /> Lo Shu Grid Analysis</p></Link>
            <Link to="/numerology/kua"><p><img src={arrow} /> Kua Number</p></Link>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Destiny;